import type {PureAction} from '@travel-frontend/state-handling-sdk';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_ACCESSIBILITY_TOGGLE =
  'uiState/accessibility/SET_ACCESSIBILITY_TOGGLE';

export const setAccessibilityToggleState = (): PureAction => {
  return {
    type: PURE(SET_ACCESSIBILITY_TOGGLE),
  };
};
